<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@/mixins/shared/formInput";
import Phone from "@/pages/components/form/input-only/phone.vue";

export default {
	mixins: [formInput],
	components: {FormGroup, Phone},
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		}
	}
}
</script>

<template>
	<FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
		<template #label v-if="$slots.label">
			<slot name="label" />
		</template>

		<template #label v-if="!$slots.label && label">
			{{ label }}
		</template>

		<Phone
			v-bind="$attrs"
			:form="form"
			:name="name"
			:id="renderedId"
			:model-value="modelValue"
			@update:modelValue="changeModelValueTo"
		>
			<template #addonafter v-if="$slots.addonafter"><slot name="addonafter" /></template>
			<template #descriptionbottom v-if="$slots.descriptionbottom"><slot name="descriptionbottom" /></template>
		</Phone>
	</FormGroup>
</template>